import { useQuery } from '@tanstack/react-query';
import { vehicleRepository } from '../../repositories/vehicle-repository';

interface UseFetchSumInsuredProps {
  data: {
    brandCode: string;
    apesegBrandCode: string;
    modelCode: string;
    apesegModelCode: string;
    year: string;
  };
}

export const useFetchSumInsured = (props: UseFetchSumInsuredProps) =>
  useQuery(
    ['vehicle-sum-insured', props],
    () => vehicleRepository.getSumInsured(props.data),
    {
      enabled: !!(
        props.data?.brandCode &&
        props.data?.apesegBrandCode &&
        props.data?.modelCode &&
        props.data?.apesegModelCode &&
        props.data?.year
      ),
    },
  );
